import { FC, RefObject } from 'react';

import { useOutsideAlerter } from '../../utils/hooks/useOutsideAlerter';
import { DesktopSubmenu, MobileSubmenu, useHeaderNavigation } from '../MegaMenu';

export interface SubmenuComponentProps {
  headerRef: RefObject<HTMLHeadingElement>;
}

export const SubmenuComponent: FC<SubmenuComponentProps> = ({ headerRef }) => {
  const { closeMenu } = useHeaderNavigation();

  useOutsideAlerter(headerRef, closeMenu);

  return (
    <>
      <MobileSubmenu />
      <DesktopSubmenu />
    </>
  );
};
